import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-laddersimple",
  "use": "icon-th-laddersimple-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-laddersimple\">\n<path d=\"M24 3C23.7348 3 23.4804 3.10536 23.2929 3.29289C23.1054 3.48043 23 3.73478 23 4V8H9V4C9 3.73478 8.89464 3.48043 8.70711 3.29289C8.51957 3.10536 8.26522 3 8 3C7.73478 3 7.48043 3.10536 7.29289 3.29289C7.10536 3.48043 7 3.73478 7 4V28C7 28.2652 7.10536 28.5196 7.29289 28.7071C7.48043 28.8946 7.73478 29 8 29C8.26522 29 8.51957 28.8946 8.70711 28.7071C8.89464 28.5196 9 28.2652 9 28V24H23V28C23 28.2652 23.1054 28.5196 23.2929 28.7071C23.4804 28.8946 23.7348 29 24 29C24.2652 29 24.5196 28.8946 24.7071 28.7071C24.8946 28.5196 25 28.2652 25 28V4C25 3.73478 24.8946 3.48043 24.7071 3.29289C24.5196 3.10536 24.2652 3 24 3ZM23 10V15H9V10H23ZM9 22V17H23V22H9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-laddersimple.svg
// module id = F6gB
// module chunks = 84